/**
 * Google Analytics 4 helper utilities.
 * Wraps gtag() calls so components don't need to reference window.gtag directly.
 */

const GA_ID = 'G-6076FCTEE6'

function gtag() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...arguments)
  }
}

/**
 * Track a page view (used for SPA route changes).
 */
export function trackPageView(path, title) {
  gtag('config', GA_ID, {
    page_path: path,
    page_title: title,
  })
}

/**
 * Track a custom event.
 * @param {string} eventName - GA4 event name
 * @param {object} params - Event parameters
 */
export function trackEvent(eventName, params = {}) {
  gtag('event', eventName, params)
}

// Pre-built event helpers for common actions

export function trackPurchaseClick(method) {
  trackEvent('purchase_click', {
    method, // 'signed_copy' or 'amazon'
  })
}

export function trackPreviewDownload() {
  trackEvent('preview_download', {
    content_type: 'pdf',
    item_name: 'Indoctri-NATION 365 Free Preview',
  })
}

export function trackCoverFlip(side) {
  trackEvent('cover_flip', {
    side, // 'front' or 'back'
  })
}

export function trackContactSubmit(subject) {
  trackEvent('contact_form_submit', {
    subject,
  })
}
